import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import "./EventPage.css";

const translations = {
  en: {
    title: "Guru Gobind Singh Ji Gurpurab 2025",
    subtitle: "Celebrating the Birth Anniversary of the Tenth Sikh Guru",
    date: "December 27, 2025",
    day: "Saturday",
    organizer: "Organized by",
    organizerName: "Picnic Gamers Members",
    sponsoredBy: "Page Built & Sponsored by",
    venue: "Venue",
    venueName: "Gurdwara Nanaksar",
    venueAddress: "255 St David Rd, Winnipeg, MB R2M 3J9, Canada",
    getDirections: "Get Directions",
    schedule: "Event Schedule",
    morning: "Morning Program",
    morningTime: "6:00 AM - 10:00 AM",
    morningEvent: "Sri Sukhmani Sahib Path",
    morningDesc: "Join us for the recitation of Sri Sukhmani Sahib, the Prayer of Peace composed by Guru Arjan Dev Ji. This sacred hymn brings tranquility and spiritual healing.",
    afternoon: "Afternoon Program", 
    afternoonTime: "10:00 AM - 6:00 PM",
    afternoonEvent: "Path Bhog & Langar Sewa",
    afternoonDesc: "Completion of Path followed by Ardas and Hukamnama. Free community meal (Langar) will be served with love to all visitors throughout the day.",
    langarNote: "Guru Ka Langar - Free community meal served to all visitors regardless of background",
    
    // Historical Section
    historicalTitle: "Guru Gobind Singh Ji's Life & Sacrifice",
    historicalIntro: "Guru Gobind Singh Ji (1666-1708) was the tenth and last human Sikh Guru. He founded the Khalsa in 1699, finalized the Guru Granth Sahib, and sacrificed his entire family for the sake of righteousness and faith. December marks the remembrance of his family's supreme sacrifice.",
    
    timeline: "Timeline of Events (December 1704)",
    event1Date: "December 5-6, 1704",
    event1Title: "Evacuation of Anandpur Sahib",
    event1Desc: "After a prolonged siege by Mughal forces and Hill Chiefs, Guru Gobind Singh Ji and his family were forced to evacuate Anandpur Sahib. During the chaotic crossing of the flooded Sirsa river, the family got separated.",
    
    event2Date: "December 7, 1704",
    event2Title: "Battle of Chamkaur",
    event2Desc: "At Chamkaur, Guru Gobind Singh Ji with only 40 Sikhs faced a massive Mughal army. Sahibzada Ajit Singh Ji (age 17) and Sahibzada Jujhar Singh Ji (age 13) fought valiantly and attained martyrdom on the battlefield.",
    
    event3Date: "December 8-11, 1704",
    event3Title: "Imprisonment at Sirhind",
    event3Desc: "Mata Gujri Ji (81) and the two younger Sahibzadas were betrayed by their servant Gangu and captured. They were imprisoned in the Cold Tower (Thanda Burj) at Sirhind by Wazir Khan, the Mughal governor.",
    
    event4Date: "December 12-13, 1704",
    event4Title: "Martyrdom at Sirhind",
    event4Desc: "When Sahibzada Zorawar Singh Ji (age 9) and Sahibzada Fateh Singh Ji (age 6) refused to convert to Islam, Wazir Khan ordered them to be bricked alive. Mata Gujri Ji died of shock upon hearing of her grandsons' martyrdom. Nawab Sher Muhammad Khan of Malerkotla raised his voice against this cruel order - an act known as 'Haa da Naara'.",
    
    todarMalTitle: "Seth Todar Mal's Sacrifice",
    todarMalDesc: "When no one dared to claim the bodies due to fear of Wazir Khan, Seth Todar Mal, a wealthy merchant of Sirhind, stepped forward. Wazir Khan demanded that he purchase the cremation land by covering it with gold coins placed vertically. Todar Mal fulfilled this demand - one of the most expensive land transactions in history - and performed the last rites with full honors.",

    sahibzadas: "The Four Sahibzadas (Chaar Sahibzade)",
    sahibzada1: "Sahibzada Ajit Singh Ji",
    sahibzada1Age: "Born: Feb 11, 1687 • Age 17",
    sahibzada1Desc: "Eldest son, martyred at Battle of Chamkaur",
    sahibzada2: "Sahibzada Jujhar Singh Ji", 
    sahibzada2Age: "Born: Mar 14, 1691 • Age 13",
    sahibzada2Desc: "Second son, martyred at Battle of Chamkaur",
    sahibzada3: "Sahibzada Zorawar Singh Ji",
    sahibzada3Age: "Born: Nov 17, 1696 • Age 9",
    sahibzada3Desc: "Third son, bricked alive at Sirhind",
    sahibzada4: "Sahibzada Fateh Singh Ji",
    sahibzada4Age: "Born: Feb 25, 1699 • Age 6",
    sahibzada4Desc: "Youngest son, bricked alive at Sirhind",

    mataGujri: "Mata Gujri Ji",
    mataGujriDesc: "Mother of Guru Gobind Singh Ji, she was 81 years old when imprisoned with her grandsons. She died of shock in the Cold Tower upon hearing of the younger Sahibzadas' martyrdom.",

    keyAspects: "Commemorations",
    aspect1Title: "Shaheedi Jor Mela",
    aspect1Text: "Annual congregation at Fatehgarh Sahib (Dec 25-27) where millions gather to pay tribute to the martyrs.",
    aspect2Title: "Veer Baal Diwas",
    aspect2Text: "December 26 was declared as 'Veer Baal Diwas' (Day of Brave Children) by the Government of India in 2022 to honor the younger Sahibzadas.",
    aspect3Title: "Gurdwara Fatehgarh Sahib",
    aspect3Text: "Built at the martyrdom site in Sirhind by Maharaja Karam Singh of Patiala. The district was renamed from Sirhind to Fatehgarh Sahib in honor of Sahibzada Fateh Singh Ji.",

    legacy: "Legacy & Significance",
    legacyText1: "The sacrifice of the Sahibzadas represents the highest form of courage and devotion to faith. Children as young as 6 and 9 refused to abandon their beliefs even when facing death.",
    legacyText2: "In 1710, Baba Banda Singh Bahadur avenged the martyrdom by defeating Wazir Khan in the Battle of Chappar Chiri and capturing Sirhind.",
    legacyText3: "The Sikhs have always honored Nawab Sher Muhammad Khan of Malerkotla for his 'Haa da Naara' (voice of protest). During the 1947 partition violence, not a single Muslim of Malerkotla was harmed by Sikhs - a testament to Sikh principles of justice and gratitude.",

    whatToBring: "What to Bring",
    bring1: "Head covering (provided if needed)",
    bring2: "Comfortable seating arrangement",
    bring3: "Open heart and peaceful mind",
    guidelines: "Guidelines",
    guideline1: "Please remove shoes before entering",
    guideline2: "Head must be covered at all times",
    guideline3: "Sit on the floor in the Darbar Sahib",
    guideline4: "Alcohol & tobacco not permitted",
    joinUs: "Join us in remembrance and prayer",
    allWelcome: "All are welcome • No registration required • All faiths welcome",
    selectLanguage: "Select Language",
    backToEvents: "← Back to Community"
  },
  pa: {
    title: "ਗੁਰੂ ਗੋਬਿੰਦ ਸਿੰਘ ਜੀ ਗੁਰਪੁਰਬ 2025",
    subtitle: "ਦਸਵੇਂ ਸਿੱਖ ਗੁਰੂ ਦੇ ਪ੍ਰਕਾਸ਼ ਪੁਰਬ ਦੀ ਖੁਸ਼ੀ",
    date: "27 ਦਸੰਬਰ, 2025",
    day: "ਸ਼ਨੀਵਾਰ",
    organizer: "ਆਯੋਜਕ",
    organizerName: "ਪਿਕਨਿਕ ਗੇਮਰਜ਼ ਮੈਂਬਰਜ਼",
    sponsoredBy: "ਪੇਜ ਬਣਾਇਆ ਅਤੇ ਸਪਾਂਸਰ ਕੀਤਾ",
    venue: "ਸਥਾਨ",
    venueName: "ਗੁਰਦੁਆਰਾ ਨਾਨਕਸਰ",
    venueAddress: "255 ਸੈਂਟ ਡੇਵਿਡ ਰੋਡ, ਵਿਨੀਪੈਗ, MB R2M 3J9, ਕੈਨੇਡਾ",
    getDirections: "ਦਿਸ਼ਾ-ਨਿਰਦੇਸ਼ ਲਓ",
    schedule: "ਪ੍ਰੋਗਰਾਮ ਦੀ ਸੂਚੀ",
    morning: "ਸਵੇਰ ਦਾ ਪ੍ਰੋਗਰਾਮ",
    morningTime: "ਸਵੇਰੇ 6:00 - 10:00 ਵਜੇ",
    morningEvent: "ਸ੍ਰੀ ਸੁਖਮਨੀ ਸਾਹਿਬ ਪਾਠ",
    morningDesc: "ਗੁਰੂ ਅਰਜਨ ਦੇਵ ਜੀ ਦੁਆਰਾ ਰਚਿਤ ਸ਼ਾਂਤੀ ਦੀ ਬਾਣੀ, ਸ੍ਰੀ ਸੁਖਮਨੀ ਸਾਹਿਬ ਦੇ ਪਾਠ ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਵੋ।",
    afternoon: "ਦੁਪਹਿਰ ਦਾ ਪ੍ਰੋਗਰਾਮ",
    afternoonTime: "ਸਵੇਰੇ 10:00 - ਸ਼ਾਮ 6:00 ਵਜੇ",
    afternoonEvent: "ਪਾਠ ਭੋਗ ਅਤੇ ਲੰਗਰ ਸੇਵਾ",
    afternoonDesc: "ਪਾਠ ਦੀ ਸਮਾਪਤੀ, ਅਰਦਾਸ ਅਤੇ ਹੁਕਮਨਾਮਾ। ਸਾਰੇ ਸੰਗਤ ਨੂੰ ਪਿਆਰ ਨਾਲ ਲੰਗਰ ਛਕਾਇਆ ਜਾਵੇਗਾ।",
    langarNote: "ਗੁਰੂ ਕਾ ਲੰਗਰ - ਸਾਰਿਆਂ ਲਈ ਮੁਫ਼ਤ ਭੋਜਨ",
    
    historicalTitle: "ਗੁਰੂ ਗੋਬਿੰਦ ਸਿੰਘ ਜੀ ਦਾ ਜੀਵਨ ਅਤੇ ਕੁਰਬਾਨੀ",
    historicalIntro: "ਗੁਰੂ ਗੋਬਿੰਦ ਸਿੰਘ ਜੀ (1666-1708) ਸਿੱਖਾਂ ਦੇ ਦਸਵੇਂ ਅਤੇ ਆਖਰੀ ਮਨੁੱਖੀ ਗੁਰੂ ਸਨ। ਉਨ੍ਹਾਂ ਨੇ 1699 ਵਿੱਚ ਖਾਲਸਾ ਸਾਜਿਆ, ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਨੂੰ ਅੰਤਿਮ ਰੂਪ ਦਿੱਤਾ, ਅਤੇ ਧਰਮ ਅਤੇ ਸੱਚ ਲਈ ਆਪਣਾ ਪੂਰਾ ਪਰਿਵਾਰ ਕੁਰਬਾਨ ਕੀਤਾ।",
    
    timeline: "ਘਟਨਾਵਾਂ ਦੀ ਸਮਾਂ-ਰੇਖਾ (ਦਸੰਬਰ 1704)",
    event1Date: "5-6 ਦਸੰਬਰ, 1704",
    event1Title: "ਅਨੰਦਪੁਰ ਸਾਹਿਬ ਛੱਡਣਾ",
    event1Desc: "ਮੁਗ਼ਲ ਫ਼ੌਜਾਂ ਅਤੇ ਪਹਾੜੀ ਰਾਜਿਆਂ ਦੇ ਲੰਬੇ ਘੇਰੇ ਤੋਂ ਬਾਅਦ, ਗੁਰੂ ਗੋਬਿੰਦ ਸਿੰਘ ਜੀ ਅਤੇ ਉਨ੍ਹਾਂ ਦੇ ਪਰਿਵਾਰ ਨੂੰ ਅਨੰਦਪੁਰ ਸਾਹਿਬ ਛੱਡਣਾ ਪਿਆ। ਸਰਸਾ ਨਦੀ ਪਾਰ ਕਰਦੇ ਸਮੇਂ ਪਰਿਵਾਰ ਵਿਛੜ ਗਿਆ।",
    
    event2Date: "7 ਦਸੰਬਰ, 1704",
    event2Title: "ਚਮਕੌਰ ਦੀ ਜੰਗ",
    event2Desc: "ਚਮਕੌਰ ਵਿਖੇ, ਗੁਰੂ ਗੋਬਿੰਦ ਸਿੰਘ ਜੀ ਨੇ ਸਿਰਫ਼ 40 ਸਿੰਘਾਂ ਨਾਲ ਵਿਸ਼ਾਲ ਮੁਗ਼ਲ ਫ਼ੌਜ ਦਾ ਸਾਹਮਣਾ ਕੀਤਾ। ਸਾਹਿਬਜ਼ਾਦਾ ਅਜੀਤ ਸਿੰਘ ਜੀ (ਉਮਰ 17) ਅਤੇ ਸਾਹਿਬਜ਼ਾਦਾ ਜੁਝਾਰ ਸਿੰਘ ਜੀ (ਉਮਰ 13) ਨੇ ਬਹਾਦਰੀ ਨਾਲ ਲੜਾਈ ਕੀਤੀ ਅਤੇ ਸ਼ਹੀਦੀ ਪ੍ਰਾਪਤ ਕੀਤੀ।",
    
    event3Date: "8-11 ਦਸੰਬਰ, 1704",
    event3Title: "ਸਰਹਿੰਦ ਵਿੱਚ ਕੈਦ",
    event3Desc: "ਮਾਤਾ ਗੁਜਰੀ ਜੀ (81) ਅਤੇ ਦੋ ਛੋਟੇ ਸਾਹਿਬਜ਼ਾਦਿਆਂ ਨੂੰ ਉਨ੍ਹਾਂ ਦੇ ਨੌਕਰ ਗੰਗੂ ਨੇ ਧੋਖਾ ਦਿੱਤਾ ਅਤੇ ਫੜਵਾ ਦਿੱਤਾ। ਉਨ੍ਹਾਂ ਨੂੰ ਵਜ਼ੀਰ ਖਾਨ, ਮੁਗ਼ਲ ਸੂਬੇਦਾਰ ਨੇ ਠੰਡੇ ਬੁਰਜ ਵਿੱਚ ਕੈਦ ਕਰ ਲਿਆ।",
    
    event4Date: "12-13 ਦਸੰਬਰ, 1704",
    event4Title: "ਸਰਹਿੰਦ ਵਿੱਚ ਸ਼ਹਾਦਤ",
    event4Desc: "ਜਦੋਂ ਸਾਹਿਬਜ਼ਾਦਾ ਜ਼ੋਰਾਵਰ ਸਿੰਘ ਜੀ (ਉਮਰ 9) ਅਤੇ ਸਾਹਿਬਜ਼ਾਦਾ ਫ਼ਤਹਿ ਸਿੰਘ ਜੀ (ਉਮਰ 6) ਨੇ ਇਸਲਾਮ ਕਬੂਲ ਕਰਨ ਤੋਂ ਇਨਕਾਰ ਕੀਤਾ, ਤਾਂ ਵਜ਼ੀਰ ਖਾਨ ਨੇ ਉਨ੍ਹਾਂ ਨੂੰ ਜ਼ਿੰਦਾ ਨੀਹਾਂ ਵਿੱਚ ਚਿਣਵਾ ਦਿੱਤਾ। ਮਾਤਾ ਗੁਜਰੀ ਜੀ ਨੇ ਆਪਣੇ ਪੋਤਿਆਂ ਦੀ ਸ਼ਹਾਦਤ ਦੀ ਖ਼ਬਰ ਸੁਣ ਕੇ ਸਦਮੇ ਨਾਲ ਪ੍ਰਾਣ ਤਿਆਗ ਦਿੱਤੇ। ਮਲੇਰਕੋਟਲੇ ਦੇ ਨਵਾਬ ਸ਼ੇਰ ਮੁਹੰਮਦ ਖਾਨ ਨੇ ਇਸ ਜ਼ੁਲਮ ਦੇ ਖ਼ਿਲਾਫ਼ ਆਵਾਜ਼ ਉਠਾਈ - ਇਸ ਨੂੰ 'ਹਾਅ ਦਾ ਨਾਅਰਾ' ਕਿਹਾ ਜਾਂਦਾ ਹੈ।",
    
    todarMalTitle: "ਸੇਠ ਟੋਡਰ ਮੱਲ ਦੀ ਕੁਰਬਾਨੀ",
    todarMalDesc: "ਜਦੋਂ ਵਜ਼ੀਰ ਖਾਨ ਦੇ ਡਰ ਕਾਰਨ ਕੋਈ ਵੀ ਲਾਸ਼ਾਂ ਲੈਣ ਨਹੀਂ ਆਇਆ, ਤਾਂ ਸਰਹਿੰਦ ਦੇ ਅਮੀਰ ਵਪਾਰੀ ਸੇਠ ਟੋਡਰ ਮੱਲ ਅੱਗੇ ਆਏ। ਵਜ਼ੀਰ ਖਾਨ ਨੇ ਸ਼ਰਤ ਰੱਖੀ ਕਿ ਉਹ ਸਸਕਾਰ ਲਈ ਜ਼ਮੀਨ ਖੜ੍ਹੇ ਕੀਤੇ ਸੋਨੇ ਦੇ ਸਿੱਕਿਆਂ ਨਾਲ ਢੱਕ ਕੇ ਖਰੀਦੇ। ਟੋਡਰ ਮੱਲ ਨੇ ਇਹ ਸ਼ਰਤ ਪੂਰੀ ਕੀਤੀ - ਇਤਿਹਾਸ ਦੇ ਸਭ ਤੋਂ ਮਹਿੰਗੇ ਜ਼ਮੀਨ ਦੇ ਸੌਦਿਆਂ ਵਿੱਚੋਂ ਇੱਕ।",

    sahibzadas: "ਚਾਰ ਸਾਹਿਬਜ਼ਾਦੇ",
    sahibzada1: "ਸਾਹਿਬਜ਼ਾਦਾ ਅਜੀਤ ਸਿੰਘ ਜੀ",
    sahibzada1Age: "ਜਨਮ: 11 ਫ਼ਰਵਰੀ, 1687 • ਉਮਰ 17",
    sahibzada1Desc: "ਵੱਡੇ ਪੁੱਤਰ, ਚਮਕੌਰ ਦੀ ਜੰਗ ਵਿੱਚ ਸ਼ਹੀਦ",
    sahibzada2: "ਸਾਹਿਬਜ਼ਾਦਾ ਜੁਝਾਰ ਸਿੰਘ ਜੀ",
    sahibzada2Age: "ਜਨਮ: 14 ਮਾਰਚ, 1691 • ਉਮਰ 13",
    sahibzada2Desc: "ਦੂਜੇ ਪੁੱਤਰ, ਚਮਕੌਰ ਦੀ ਜੰਗ ਵਿੱਚ ਸ਼ਹੀਦ",
    sahibzada3: "ਸਾਹਿਬਜ਼ਾਦਾ ਜ਼ੋਰਾਵਰ ਸਿੰਘ ਜੀ",
    sahibzada3Age: "ਜਨਮ: 17 ਨਵੰਬਰ, 1696 • ਉਮਰ 9",
    sahibzada3Desc: "ਤੀਜੇ ਪੁੱਤਰ, ਸਰਹਿੰਦ ਵਿੱਚ ਨੀਹਾਂ ਵਿੱਚ ਚਿਣਵਾਏ",
    sahibzada4: "ਸਾਹਿਬਜ਼ਾਦਾ ਫ਼ਤਹਿ ਸਿੰਘ ਜੀ",
    sahibzada4Age: "ਜਨਮ: 25 ਫ਼ਰਵਰੀ, 1699 • ਉਮਰ 6",
    sahibzada4Desc: "ਸਭ ਤੋਂ ਛੋਟੇ ਪੁੱਤਰ, ਸਰਹਿੰਦ ਵਿੱਚ ਨੀਹਾਂ ਵਿੱਚ ਚਿਣਵਾਏ",

    mataGujri: "ਮਾਤਾ ਗੁਜਰੀ ਜੀ",
    mataGujriDesc: "ਗੁਰੂ ਗੋਬਿੰਦ ਸਿੰਘ ਜੀ ਦੀ ਮਾਤਾ, ਜਦੋਂ ਉਨ੍ਹਾਂ ਨੂੰ ਆਪਣੇ ਪੋਤਿਆਂ ਨਾਲ ਕੈਦ ਕੀਤਾ ਗਿਆ ਤਾਂ ਉਹ 81 ਸਾਲਾਂ ਦੀਆਂ ਸਨ। ਛੋਟੇ ਸਾਹਿਬਜ਼ਾਦਿਆਂ ਦੀ ਸ਼ਹਾਦਤ ਸੁਣ ਕੇ ਠੰਡੇ ਬੁਰਜ ਵਿੱਚ ਉਨ੍ਹਾਂ ਦਾ ਦੇਹਾਂਤ ਹੋ ਗਿਆ।",

    keyAspects: "ਯਾਦਗਾਰੀ ਸਮਾਗਮ",
    aspect1Title: "ਸ਼ਹੀਦੀ ਜੋੜ ਮੇਲਾ",
    aspect1Text: "ਫ਼ਤਹਿਗੜ੍ਹ ਸਾਹਿਬ ਵਿਖੇ ਸਲਾਨਾ ਮੇਲਾ (25-27 ਦਸੰਬਰ) ਜਿੱਥੇ ਲੱਖਾਂ ਲੋਕ ਸ਼ਹੀਦਾਂ ਨੂੰ ਸ਼ਰਧਾਂਜਲੀ ਦੇਣ ਆਉਂਦੇ ਹਨ।",
    aspect2Title: "ਵੀਰ ਬਾਲ ਦਿਵਸ",
    aspect2Text: "26 ਦਸੰਬਰ ਨੂੰ ਭਾਰਤ ਸਰਕਾਰ ਨੇ 2022 ਵਿੱਚ ਛੋਟੇ ਸਾਹਿਬਜ਼ਾਦਿਆਂ ਦੇ ਸਨਮਾਨ ਵਿੱਚ 'ਵੀਰ ਬਾਲ ਦਿਵਸ' ਐਲਾਨ ਕੀਤਾ।",
    aspect3Title: "ਗੁਰਦੁਆਰਾ ਫ਼ਤਹਿਗੜ੍ਹ ਸਾਹਿਬ",
    aspect3Text: "ਸਰਹਿੰਦ ਵਿੱਚ ਸ਼ਹਾਦਤ ਦੀ ਥਾਂ 'ਤੇ ਪਟਿਆਲਾ ਦੇ ਮਹਾਰਾਜਾ ਕਰਮ ਸਿੰਘ ਨੇ ਬਣਾਇਆ। ਜ਼ਿਲ੍ਹੇ ਦਾ ਨਾਂ ਸਰਹਿੰਦ ਤੋਂ ਬਦਲ ਕੇ ਫ਼ਤਹਿਗੜ੍ਹ ਸਾਹਿਬ ਰੱਖਿਆ ਗਿਆ।",

    legacy: "ਵਿਰਾਸਤ ਅਤੇ ਮਹੱਤਵ",
    legacyText1: "ਸਾਹਿਬਜ਼ਾਦਿਆਂ ਦੀ ਕੁਰਬਾਨੀ ਸਭ ਤੋਂ ਉੱਚੇ ਦਰਜੇ ਦੀ ਹਿੰਮਤ ਅਤੇ ਧਰਮ ਪ੍ਰਤੀ ਸਮਰਪਣ ਨੂੰ ਦਰਸਾਉਂਦੀ ਹੈ। 6 ਅਤੇ 9 ਸਾਲ ਦੇ ਬੱਚਿਆਂ ਨੇ ਮੌਤ ਦੇ ਸਾਹਮਣੇ ਵੀ ਆਪਣਾ ਧਰਮ ਨਹੀਂ ਛੱਡਿਆ।",
    legacyText2: "1710 ਵਿੱਚ, ਬਾਬਾ ਬੰਦਾ ਸਿੰਘ ਬਹਾਦਰ ਨੇ ਚੱਪੜਚਿੜੀ ਦੀ ਜੰਗ ਵਿੱਚ ਵਜ਼ੀਰ ਖਾਨ ਨੂੰ ਹਰਾ ਕੇ ਸਰਹਿੰਦ 'ਤੇ ਕਬਜ਼ਾ ਕਰ ਕੇ ਸ਼ਹਾਦਤ ਦਾ ਬਦਲਾ ਲਿਆ।",
    legacyText3: "ਸਿੱਖਾਂ ਨੇ ਹਮੇਸ਼ਾ ਮਲੇਰਕੋਟਲੇ ਦੇ ਨਵਾਬ ਸ਼ੇਰ ਮੁਹੰਮਦ ਖਾਨ ਦੇ 'ਹਾਅ ਦੇ ਨਾਅਰੇ' ਦਾ ਸਨਮਾਨ ਕੀਤਾ। 1947 ਦੀ ਵੰਡ ਦੌਰਾਨ, ਸਿੱਖਾਂ ਨੇ ਮਲੇਰਕੋਟਲੇ ਦੇ ਇੱਕ ਵੀ ਮੁਸਲਮਾਨ ਨੂੰ ਨੁਕਸਾਨ ਨਹੀਂ ਪਹੁੰਚਾਇਆ।",

    whatToBring: "ਕੀ ਲਿਆਉਣਾ ਹੈ",
    bring1: "ਸਿਰ ਢੱਕਣ ਲਈ ਕੱਪੜਾ (ਲੋੜ ਪੈਣ 'ਤੇ ਮਿਲੇਗਾ)",
    bring2: "ਆਰਾਮਦਾਇਕ ਬੈਠਣ ਦਾ ਪ੍ਰਬੰਧ",
    bring3: "ਖੁੱਲ੍ਹਾ ਦਿਲ ਅਤੇ ਸ਼ਾਂਤ ਮਨ",
    guidelines: "ਦਿਸ਼ਾ-ਨਿਰਦੇਸ਼",
    guideline1: "ਅੰਦਰ ਜਾਣ ਤੋਂ ਪਹਿਲਾਂ ਜੁੱਤੀ ਉਤਾਰੋ",
    guideline2: "ਸਿਰ ਹਮੇਸ਼ਾ ਢੱਕਿਆ ਰਹਿਣਾ ਚਾਹੀਦਾ",
    guideline3: "ਦਰਬਾਰ ਸਾਹਿਬ ਵਿੱਚ ਜ਼ਮੀਨ 'ਤੇ ਬੈਠੋ",
    guideline4: "ਸ਼ਰਾਬ ਅਤੇ ਤੰਬਾਕੂ ਦੀ ਮਨਾਹੀ",
    joinUs: "ਯਾਦ ਅਤੇ ਅਰਦਾਸ ਵਿੱਚ ਸਾਡੇ ਨਾਲ ਸ਼ਾਮਲ ਹੋਵੋ",
    allWelcome: "ਸਾਰਿਆਂ ਦਾ ਸਵਾਗਤ ਹੈ • ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਦੀ ਲੋੜ ਨਹੀਂ • ਸਾਰੇ ਧਰਮਾਂ ਦਾ ਸਵਾਗਤ",
    selectLanguage: "ਭਾਸ਼ਾ ਚੁਣੋ",
    backToEvents: "← ਕਮਿਊਨਿਟੀ 'ਤੇ ਵਾਪਸ"
  },
  hi: {
    title: "गुरु गोबिंद सिंह जी गुरपुरब 2025",
    subtitle: "दसवें सिख गुरु के प्रकाश पर्व का उत्सव",
    date: "27 दिसंबर, 2025",
    day: "शनिवार",
    organizer: "आयोजक",
    organizerName: "पिकनिक गेमर्स मेंबर्स",
    sponsoredBy: "पेज निर्माण एवं प्रायोजित",
    venue: "स्थान",
    venueName: "गुरुद्वारा नानकसर",
    venueAddress: "255 सेंट डेविड रोड, विनिपेग, MB R2M 3J9, कनाडा",
    getDirections: "दिशा-निर्देश प्राप्त करें",
    schedule: "कार्यक्रम सूची",
    morning: "प्रातः कार्यक्रम",
    morningTime: "प्रातः 6:00 - 10:00 बजे",
    morningEvent: "श्री सुखमनी साहिब पाठ",
    morningDesc: "गुरु अर्जन देव जी द्वारा रचित शांति की बाणी, श्री सुखमनी साहिब के पाठ में शामिल हों।",
    afternoon: "दोपहर का कार्यक्रम",
    afternoonTime: "प्रातः 10:00 - सायं 6:00 बजे",
    afternoonEvent: "पाठ भोग एवं लंगर सेवा",
    afternoonDesc: "पाठ की समाप्ति, अरदास और हुकमनामा। सभी संगत को प्रेम से लंगर छकाया जाएगा।",
    langarNote: "गुरु का लंगर - सभी के लिए निःशुल्क भोजन",
    
    historicalTitle: "गुरु गोबिंद सिंह जी का जीवन और बलिदान",
    historicalIntro: "गुरु गोबिंद सिंह जी (1666-1708) सिखों के दसवें और अंतिम मानव गुरु थे। उन्होंने 1699 में खालसा की स्थापना की, गुरु ग्रंथ साहिब को अंतिम रूप दिया, और धर्म और सत्य के लिए अपना पूरा परिवार कुर्बान किया।",
    
    timeline: "घटनाओं की समय-रेखा (दिसंबर 1704)",
    event1Date: "5-6 दिसंबर, 1704",
    event1Title: "आनंदपुर साहिब छोड़ना",
    event1Desc: "मुगल सेना और पहाड़ी राजाओं के लंबे घेराव के बाद, गुरु गोबिंद सिंह जी और उनके परिवार को आनंदपुर साहिब छोड़ना पड़ा। सरसा नदी पार करते समय परिवार बिछड़ गया।",
    
    event2Date: "7 दिसंबर, 1704",
    event2Title: "चमकौर की जंग",
    event2Desc: "चमकौर में, गुरु गोबिंद सिंह जी ने केवल 40 सिंघों के साथ विशाल मुगल सेना का सामना किया। साहिबज़ादा अजीत सिंह जी (आयु 17) और साहिबज़ादा जुझार सिंह जी (आयु 13) ने वीरता से लड़ाई की और शहीदी प्राप्त की।",
    
    event3Date: "8-11 दिसंबर, 1704",
    event3Title: "सरहिंद में कैद",
    event3Desc: "माता गुजरी जी (81) और दो छोटे साहिबज़ादों को उनके नौकर गंगू ने धोखा दिया और पकड़वा दिया। उन्हें वज़ीर खान, मुगल सूबेदार ने ठंडे बुर्ज में कैद कर लिया।",
    
    event4Date: "12-13 दिसंबर, 1704",
    event4Title: "सरहिंद में शहादत",
    event4Desc: "जब साहिबज़ादा ज़ोरावर सिंह जी (आयु 9) और साहिबज़ादा फ़तेह सिंह जी (आयु 6) ने इस्लाम कबूल करने से इनकार किया, तो वज़ीर खान ने उन्हें जीवित दीवार में चुनवा दिया। माता गुजरी जी ने अपने पोतों की शहादत सुनकर सदमे से प्राण त्याग दिए। मलेरकोटला के नवाब शेर मुहम्मद खान ने इस जुल्म के खिलाफ आवाज उठाई - इसे 'हाअ दा नारा' कहा जाता है।",
    
    todarMalTitle: "सेठ टोडर मल का बलिदान",
    todarMalDesc: "जब वज़ीर खान के डर के कारण कोई भी शवों को लेने नहीं आया, तो सरहिंद के धनी व्यापारी सेठ टोडर मल आगे आए। वज़ीर खान ने शर्त रखी कि वे दाह संस्कार के लिए जमीन खड़े किए सोने के सिक्कों से ढककर खरीदें। टोडर मल ने यह शर्त पूरी की - इतिहास के सबसे महंगे भूमि सौदों में से एक।",

    sahibzadas: "चार साहिबज़ादे",
    sahibzada1: "साहिबज़ादा अजीत सिंह जी",
    sahibzada1Age: "जन्म: 11 फ़रवरी, 1687 • आयु 17",
    sahibzada1Desc: "बड़े पुत्र, चमकौर की जंग में शहीद",
    sahibzada2: "साहिबज़ादा जुझार सिंह जी",
    sahibzada2Age: "जन्म: 14 मार्च, 1691 • आयु 13",
    sahibzada2Desc: "दूसरे पुत्र, चमकौर की जंग में शहीद",
    sahibzada3: "साहिबज़ादा ज़ोरावर सिंह जी",
    sahibzada3Age: "जन्म: 17 नवंबर, 1696 • आयु 9",
    sahibzada3Desc: "तीसरे पुत्र, सरहिंद में दीवार में चुने गए",
    sahibzada4: "साहिबज़ादा फ़तेह सिंह जी",
    sahibzada4Age: "जन्म: 25 फ़रवरी, 1699 • आयु 6",
    sahibzada4Desc: "सबसे छोटे पुत्र, सरहिंद में दीवार में चुने गए",

    mataGujri: "माता गुजरी जी",
    mataGujriDesc: "गुरु गोबिंद सिंह जी की माता, जब उन्हें अपने पोतों के साथ कैद किया गया तब वे 81 वर्ष की थीं। छोटे साहिबज़ादों की शहादत सुनकर ठंडे बुर्ज में उनका देहांत हो गया।",

    keyAspects: "स्मृति समारोह",
    aspect1Title: "शहीदी जोड़ मेला",
    aspect1Text: "फ़तेहगढ़ साहिब में वार्षिक मेला (25-27 दिसंबर) जहां लाखों लोग शहीदों को श्रद्धांजलि देने आते हैं।",
    aspect2Title: "वीर बाल दिवस",
    aspect2Text: "26 दिसंबर को भारत सरकार ने 2022 में छोटे साहिबज़ादों के सम्मान में 'वीर बाल दिवस' घोषित किया।",
    aspect3Title: "गुरुद्वारा फ़तेहगढ़ साहिब",
    aspect3Text: "सरहिंद में शहादत स्थल पर पटियाला के महाराजा करम सिंह ने बनवाया। जिले का नाम सरहिंद से बदलकर फ़तेहगढ़ साहिब रखा गया।",

    legacy: "विरासत और महत्व",
    legacyText1: "साहिबज़ादों का बलिदान सबसे उच्च स्तर की हिम्मत और धर्म के प्रति समर्पण को दर्शाता है। 6 और 9 वर्ष के बच्चों ने मृत्यु के सामने भी अपना धर्म नहीं छोड़ा।",
    legacyText2: "1710 में, बाबा बंदा सिंह बहादुर ने चप्पड़चिड़ी की जंग में वज़ीर खान को हराकर सरहिंद पर कब्जा करके शहादत का बदला लिया।",
    legacyText3: "सिखों ने हमेशा मलेरकोटला के नवाब शेर मुहम्मद खान के 'हाअ दे नारे' का सम्मान किया। 1947 के विभाजन के दौरान, सिखों ने मलेरकोटला के एक भी मुसलमान को नुकसान नहीं पहुंचाया।",

    whatToBring: "क्या लाएं",
    bring1: "सिर ढकने के लिए कपड़ा (जरूरत पड़ने पर मिलेगा)",
    bring2: "आरामदायक बैठने की व्यवस्था",
    bring3: "खुला दिल और शांत मन",
    guidelines: "दिशा-निर्देश",
    guideline1: "अंदर जाने से पहले जूते उतारें",
    guideline2: "सिर हमेशा ढका रहना चाहिए",
    guideline3: "दरबार साहिब में जमीन पर बैठें",
    guideline4: "शराब और तंबाकू की मनाही",
    joinUs: "स्मृति और प्रार्थना में हमारे साथ जुड़ें",
    allWelcome: "सभी का स्वागत है • पंजीकरण आवश्यक नहीं • सभी धर्मों का स्वागत",
    selectLanguage: "भाषा चुनें",
    backToEvents: "← कम्युनिटी पर वापस"
  },
  fr: {
    title: "Gurpurab de Guru Gobind Singh Ji 2025",
    subtitle: "Célébration de l'anniversaire du dixième Guru Sikh",
    date: "27 décembre 2025",
    day: "Samedi",
    organizer: "Organisé par",
    organizerName: "Membres de Picnic Gamers",
    sponsoredBy: "Page créée et sponsorisée par",
    venue: "Lieu",
    venueName: "Gurdwara Nanaksar",
    venueAddress: "255 St David Rd, Winnipeg, MB R2M 3J9, Canada",
    getDirections: "Obtenir l'itinéraire",
    schedule: "Programme de l'événement",
    morning: "Programme du matin",
    morningTime: "6h00 - 10h00",
    morningEvent: "Sri Sukhmani Sahib Path",
    morningDesc: "Rejoignez-nous pour la récitation de Sri Sukhmani Sahib, la Prière de la Paix composée par Guru Arjan Dev Ji.",
    afternoon: "Programme de l'après-midi",
    afternoonTime: "10h00 - 18h00",
    afternoonEvent: "Path Bhog & Langar Sewa",
    afternoonDesc: "Achèvement du Path suivi de l'Ardas et du Hukamnama. Un repas communautaire gratuit (Langar) sera servi avec amour.",
    langarNote: "Guru Ka Langar - Repas communautaire gratuit servi à tous les visiteurs",
    
    historicalTitle: "Vie et Sacrifice de Guru Gobind Singh Ji",
    historicalIntro: "Guru Gobind Singh Ji (1666-1708) fut le dixième et dernier Guru Sikh humain. Il fonda le Khalsa en 1699, finalisa le Guru Granth Sahib et sacrifia toute sa famille pour la justice et la foi.",
    
    timeline: "Chronologie des événements (décembre 1704)",
    event1Date: "5-6 décembre 1704",
    event1Title: "Évacuation d'Anandpur Sahib",
    event1Desc: "Après un long siège, Guru Gobind Singh Ji et sa famille furent forcés d'évacuer. Lors de la traversée de la rivière Sirsa en crue, la famille fut séparée.",
    
    event2Date: "7 décembre 1704",
    event2Title: "Bataille de Chamkaur",
    event2Desc: "À Chamkaur, Guru Gobind Singh Ji avec seulement 40 Sikhs affronta une immense armée moghole. Sahibzada Ajit Singh Ji (17 ans) et Sahibzada Jujhar Singh Ji (13 ans) atteignirent le martyre.",
    
    event3Date: "8-11 décembre 1704",
    event3Title: "Emprisonnement à Sirhind",
    event3Desc: "Mata Gujri Ji (81 ans) et les deux plus jeunes Sahibzadas furent trahis et capturés. Ils furent emprisonnés dans la Tour Froide (Thanda Burj).",
    
    event4Date: "12-13 décembre 1704",
    event4Title: "Martyre à Sirhind",
    event4Desc: "Quand Sahibzada Zorawar Singh Ji (9 ans) et Sahibzada Fateh Singh Ji (6 ans) refusèrent de se convertir, ils furent emmurés vivants. Mata Gujri Ji mourut de choc. Nawab Sher Muhammad Khan de Malerkotla protesta contre cet acte cruel.",
    
    todarMalTitle: "Le Sacrifice de Seth Todar Mal",
    todarMalDesc: "Quand personne n'osa réclamer les corps, Seth Todar Mal, un riche marchand, se manifesta. Wazir Khan exigea qu'il achète le terrain de crémation avec des pièces d'or placées verticalement.",

    sahibzadas: "Les Quatre Sahibzadas",
    sahibzada1: "Sahibzada Ajit Singh Ji",
    sahibzada1Age: "Né: 11 février 1687 • 17 ans",
    sahibzada1Desc: "Fils aîné, martyr à la bataille de Chamkaur",
    sahibzada2: "Sahibzada Jujhar Singh Ji",
    sahibzada2Age: "Né: 14 mars 1691 • 13 ans",
    sahibzada2Desc: "Deuxième fils, martyr à la bataille de Chamkaur",
    sahibzada3: "Sahibzada Zorawar Singh Ji",
    sahibzada3Age: "Né: 17 novembre 1696 • 9 ans",
    sahibzada3Desc: "Troisième fils, emmuré vivant à Sirhind",
    sahibzada4: "Sahibzada Fateh Singh Ji",
    sahibzada4Age: "Né: 25 février 1699 • 6 ans",
    sahibzada4Desc: "Plus jeune fils, emmuré vivant à Sirhind",

    mataGujri: "Mata Gujri Ji",
    mataGujriDesc: "Mère de Guru Gobind Singh Ji, elle avait 81 ans lorsqu'elle fut emprisonnée avec ses petits-fils. Elle mourut dans la Tour Froide après avoir appris le martyre des jeunes Sahibzadas.",

    keyAspects: "Commémorations",
    aspect1Title: "Shaheedi Jor Mela",
    aspect1Text: "Rassemblement annuel à Fatehgarh Sahib (25-27 décembre) où des millions viennent rendre hommage aux martyrs.",
    aspect2Title: "Veer Baal Diwas",
    aspect2Text: "Le gouvernement indien a déclaré le 26 décembre 'Veer Baal Diwas' en 2022 en l'honneur des jeunes Sahibzadas.",
    aspect3Title: "Gurdwara Fatehgarh Sahib",
    aspect3Text: "Construit sur le site du martyre à Sirhind par Maharaja Karam Singh de Patiala.",

    legacy: "Héritage et Importance",
    legacyText1: "Le sacrifice des Sahibzadas représente le plus haut niveau de courage et de dévotion à la foi. Des enfants de 6 et 9 ans ont refusé de renoncer à leur foi face à la mort.",
    legacyText2: "En 1710, Baba Banda Singh Bahadur a vengé le martyre en battant Wazir Khan et en capturant Sirhind.",
    legacyText3: "Les Sikhs ont toujours respecté le 'Haa da Naara' de Nawab Sher Muhammad Khan de Malerkotla. Pendant la partition de 1947, aucun musulman de Malerkotla n'a été blessé.",

    whatToBring: "Que Apporter",
    bring1: "Couvre-chef (disponible sur place si nécessaire)",
    bring2: "Chaise confortable pour s'asseoir",
    bring3: "Cœur ouvert et esprit paisible",
    guidelines: "Directives",
    guideline1: "Retirer les chaussures avant d'entrer",
    guideline2: "La tête doit toujours être couverte",
    guideline3: "S'asseoir par terre dans le Darbar Sahib",
    guideline4: "Alcool et tabac interdits",
    joinUs: "Rejoignez-nous dans la commémoration et la prière",
    allWelcome: "Tous sont les bienvenus • Pas d'inscription requise • Toutes les confessions bienvenues",
    selectLanguage: "Langue",
    backToEvents: "← Retour à la Communauté"
  }
};

export const GuruGobindSinghGurpurab = () => {
  const { language: lang } = useLanguage();
  const t = translations[lang] || translations.en;

  return (
    <div className="event-page">
      {/* Khanda Background */}
      <div className="khanda-bg"></div>

      {/* Back Link - positioned below nav header */}
      <div className="back-link-container">
        <Link to="/community" className="back-link">{t.backToEvents}</Link>
      </div>

      {/* Hero Section */}
      <header className="event-hero">
        <div className="event-hero-content">
          <div className="khanda-icon">☬</div>
          <p className="event-date">{t.date} • {t.day}</p>
          <h1>{t.title}</h1>
          <p className="event-subtitle">{t.subtitle}</p>
        </div>
      </header>

      {/* Venue Section */}
      <section className="venue-section">
        <div className="container">
          <div className="venue-card">
            <div className="venue-info">
              <div className="venue-icon">🕌</div>
              <div className="venue-details">
                <p className="label">{t.venue}</p>
                <h3>{t.venueName}</h3>
                <p className="address">{t.venueAddress}</p>
                <a 
                  href="https://www.google.com/maps/dir/?api=1&destination=255+St+David+Rd,+Winnipeg,+MB+R2M+3J9,+Canada" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="directions-btn"
                >
                  📍 {t.getDirections}
                </a>
              </div>
            </div>
            <div className="venue-map">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2573.8845!2d-97.1044!3d49.8391!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x52ea73f8a7b7c8cd%3A0x1234567890abcdef!2s255%20St%20David%20Rd%2C%20Winnipeg%2C%20MB%20R2M%203J9%2C%20Canada!5e0!3m2!1sen!2sca!4v1234567890"
                width="100%" 
                height="200" 
                style={{border: 0, borderRadius: '12px'}}
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Gurdwara Location"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Schedule Section */}
      <section className="schedule-section">
        <div className="container">
          <h2>{t.schedule}</h2>
          <div className="schedule-grid">
            <div className="schedule-card morning">
              <div className="time-badge">{t.morningTime}</div>
              <h3>{t.morning}</h3>
              <p className="event-name">{t.morningEvent}</p>
              <p className="event-desc">{t.morningDesc}</p>
            </div>
            <div className="schedule-card afternoon">
              <div className="time-badge">{t.afternoonTime}</div>
              <h3>{t.afternoon}</h3>
              <p className="event-name">{t.afternoonEvent}</p>
              <p className="event-desc">{t.afternoonDesc}</p>
            </div>
          </div>
          <p className="langar-note">🙏 {t.langarNote}</p>
        </div>
      </section>

      {/* Historical Background Section */}
      <section className="history-section">
        <div className="container">
          <h2>{t.historicalTitle}</h2>
          <p className="history-intro">{t.historicalIntro}</p>
          
          <h3 className="timeline-title">{t.timeline}</h3>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-date">{t.event1Date}</div>
              <div className="timeline-content">
                <h4>{t.event1Title}</h4>
                <p>{t.event1Desc}</p>
              </div>
            </div>
            <div className="timeline-item chamkaur">
              <div className="timeline-date">{t.event2Date}</div>
              <div className="timeline-content">
                <h4>{t.event2Title}</h4>
                <p>{t.event2Desc}</p>
              </div>
            </div>
            <div className="timeline-item">
              <div className="timeline-date">{t.event3Date}</div>
              <div className="timeline-content">
                <h4>{t.event3Title}</h4>
                <p>{t.event3Desc}</p>
              </div>
            </div>
            <div className="timeline-item sirhind">
              <div className="timeline-date">{t.event4Date}</div>
              <div className="timeline-content">
                <h4>{t.event4Title}</h4>
                <p>{t.event4Desc}</p>
              </div>
            </div>
          </div>

          <div className="todar-mal-card">
            <h4>🏆 {t.todarMalTitle}</h4>
            <p>{t.todarMalDesc}</p>
          </div>
        </div>
      </section>

      {/* Sahibzadas Section */}
      <section className="sahibzadas-section">
        <div className="container">
          <h2>{t.sahibzadas}</h2>
          <div className="sahibzadas-grid">
            <div className="sahibzada-card chamkaur-martyr">
              <div className="sahibzada-image">
                <span className="martyr-icon">⚔️</span>
              </div>
              <h4>{t.sahibzada1}</h4>
              <p className="sahibzada-age">{t.sahibzada1Age}</p>
              <p className="sahibzada-desc">{t.sahibzada1Desc}</p>
            </div>
            <div className="sahibzada-card chamkaur-martyr">
              <div className="sahibzada-image">
                <span className="martyr-icon">⚔️</span>
              </div>
              <h4>{t.sahibzada2}</h4>
              <p className="sahibzada-age">{t.sahibzada2Age}</p>
              <p className="sahibzada-desc">{t.sahibzada2Desc}</p>
            </div>
            <div className="sahibzada-card sirhind-martyr">
              <div className="sahibzada-image">
                <span className="martyr-icon">🕯️</span>
              </div>
              <h4>{t.sahibzada3}</h4>
              <p className="sahibzada-age">{t.sahibzada3Age}</p>
              <p className="sahibzada-desc">{t.sahibzada3Desc}</p>
            </div>
            <div className="sahibzada-card sirhind-martyr">
              <div className="sahibzada-image">
                <span className="martyr-icon">🕯️</span>
              </div>
              <h4>{t.sahibzada4}</h4>
              <p className="sahibzada-age">{t.sahibzada4Age}</p>
              <p className="sahibzada-desc">{t.sahibzada4Desc}</p>
            </div>
          </div>

          <div className="mata-gujri-card">
            <h4>🙏 {t.mataGujri}</h4>
            <p>{t.mataGujriDesc}</p>
          </div>
        </div>
      </section>

      {/* Key Aspects Section */}
      <section className="about-section">
        <div className="container">
          <h3 className="aspects-title">{t.keyAspects}</h3>
          <div className="aspects-grid">
            <div className="aspect-card">
              <div className="aspect-icon">🎪</div>
              <h4>{t.aspect1Title}</h4>
              <p>{t.aspect1Text}</p>
            </div>
            <div className="aspect-card">
              <div className="aspect-icon">🇮🇳</div>
              <h4>{t.aspect2Title}</h4>
              <p>{t.aspect2Text}</p>
            </div>
            <div className="aspect-card">
              <div className="aspect-icon">🕌</div>
              <h4>{t.aspect3Title}</h4>
              <p>{t.aspect3Text}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Legacy Section */}
      <section className="legacy-section">
        <div className="container">
          <h2>{t.legacy}</h2>
          <div className="legacy-content">
            <p>{t.legacyText1}</p>
            <p>{t.legacyText2}</p>
            <p>{t.legacyText3}</p>
          </div>
        </div>
      </section>

      {/* Organizer Section */}
      <section className="organizer-section">
        <div className="container">
          <div className="organizer-card">
            <p className="label">{t.organizer}</p>
            <h3>{t.organizerName}</h3>
          </div>
          <div className="sponsor-card">
            <p className="label">{t.sponsoredBy}</p>
            <div className="sponsors">
              <a href="https://9reason.com" target="_blank" rel="noopener noreferrer" className="sponsor">
                <div className="sponsor-logo">
                  <svg viewBox="0 0 40 40">
                    <rect width="40" height="40" rx="8" fill="#4F46E5"/>
                    <text x="20" y="27" fontFamily="sans-serif" fontSize="22" fontWeight="700" fill="#fff" textAnchor="middle">9</text>
                  </svg>
                </div>
                <span>9reason.com</span>
              </a>
              <a href="https://realtorparmindersingh.ca" target="_blank" rel="noopener noreferrer" className="sponsor">
                <div className="sponsor-logo realtor">🏠</div>
                <span>realtorparmindersingh.ca</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Guidelines Section */}
      <section className="guidelines-section">
        <div className="container">
          <div className="guidelines-grid">
            <div className="guideline-card">
              <h3>📋 {t.whatToBring}</h3>
              <ul>
                <li>{t.bring1}</li>
                <li>{t.bring2}</li>
                <li>{t.bring3}</li>
              </ul>
            </div>
            <div className="guideline-card">
              <h3>📜 {t.guidelines}</h3>
              <ul>
                <li>{t.guideline1}</li>
                <li>{t.guideline2}</li>
                <li>{t.guideline3}</li>
                <li>{t.guideline4}</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="khanda-large">☬</div>
          <h2>{t.joinUs}</h2>
          <p>{t.allWelcome}</p>
          <div className="waheguru">ਵਾਹਿਗੁਰੂ ਜੀ ਕਾ ਖਾਲਸਾ, ਵਾਹਿਗੁਰੂ ਜੀ ਕੀ ਫਤਹਿ</div>
        </div>
      </section>

      {/* Footer */}
      <footer className="event-footer">
        <p>© 2025 • Built with ❤️ by <a href="https://9reason.com">9Reason</a></p>
      </footer>
    </div>
  );
};
